import { useFormContext } from "react-hook-form";
import { selfExclusionCreatePayload } from "../helpers/SelfExclusion/selfExclusionSubmission";
import useLogin from "./useLogin";
import LoadingAction from "@common/redux/actions/LoadingAction";
import LoginAction from "@common/redux/actions/LoginAction";
import AlertModalAction from "@common/redux/actions/AlertModalAction";
import SelfExclusionClient from "@common/api/SelfExclusionClient";
import { handleError } from "@common/components/helpers/error";
import { useHistory } from "react-router-dom";
import { handleReset } from "@common/components/helpers/reset";
import { useEffect } from "react";
import { mapToSelect } from "@common/components/helpers/forms";
import { parseSelfExclusionResponse } from "../helpers/compliance.js";

const fetchSelfExclusionMetaData = (methods) => {
  SelfExclusionClient.MetaData().then((response) => {
    const options = mapToSelect(response.selfExclusionTypes);
    methods.setValue("selfExclusionTypes", options);
  });
};

const useSelfExclusionForm = () => {
  const history = useHistory();
  const methods = useFormContext();
  const {
    reset,
    getValues,
    formState: { isValid },
  } = methods;

  const [{ isDesktop, siteGuid }] = useLogin();

  useEffect(() => {
    fetchSelfExclusionMetaData(methods);
  }, []);

  const onReset = () => {
    handleReset(reset);
    fetchSelfExclusionMetaData(methods);
  };

  const onSubmit = (data) => {
    if (!isValid) {
      return;
    }
    const payload = selfExclusionCreatePayload(data, siteGuid);
    const fnSubmit = isDesktop
      ? SelfExclusionClient.Update
      : SelfExclusionClient.Create;

    LoadingAction.set(true).then(() =>
      fnSubmit(payload)
        .then((record) => {
          AlertModalAction.open(
            "The self exclusion record was successfully submitted!",
            "Success",
            isDesktop ? () => {} : () => history.push("/compliance"),
          );

          if (!isDesktop) {
            reset();
          } else {
            reset({
              ...getValues(),
              ...parseSelfExclusionResponse({ record }),
            });

            LoginAction.dispatch({ isInReadMode: true });
          }
        })
        .catch((error) => {
          handleError(
            error,
            "Errors",
            "There is an error submitting self exclusion record.",
          );
        })
        .finally(() => LoadingAction.set(false)),
    );
  };

  return { methods, onSubmit, onReset };
};

export default useSelfExclusionForm;
